import { post_event } from './analytics'

const sendBookClickEvent = book => {
  post_event('PremiumLockBookName', book.slug)
  post_event('PremiumLock', 'click-locked-book')
}

const PremiumLock = {
  sendBookClickEvent
}

export default PremiumLock
